var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConnGtm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 102,
    viewBox: "0 0 102 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8.02643C0 3.59356 3.59356 0 8.02644 0H93.9736C98.4064 0 102 3.59356 102 8.02644V93.9736C102 98.4064 98.4064 102 93.9736 102H8.02643C3.59356 102 0 98.4064 0 93.9736V8.02643Z",
    fill: "#FBF8EA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4333 32.2106L58.1727 51.0407C58.3023 51.1709 58.3023 51.3813 58.1727 51.5116L51.6425 58.0734L64.1816 70.5074L79.9035 54.572C81.7042 52.7469 81.6979 49.8117 79.8893 47.9943L55.1194 23.1046C53.2929 21.2692 50.3221 21.2692 48.4955 23.1046L39.4333 32.2106Z",
    fill: "#2979FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51.7821 57.8247L38.7656 70.3405L48.2434 79.4538C50.2089 81.3437 53.3253 81.3131 55.2534 79.3851L64.2979 70.3405L51.7821 57.8247Z",
    fill: "#2962FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M63.9648 31.9587L45.0098 50.9136C44.8795 51.044 44.8795 51.2553 45.0098 51.3856L51.6158 57.9916L38.9331 70.5074L23.0177 54.4536C21.2064 52.6265 21.2128 49.6791 23.0319 47.8599L48.1449 22.7469C49.9697 20.9221 52.9282 20.9221 54.7529 22.7469L63.9648 31.9587Z",
    fill: "#4FC3F7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnGtm);
export default __webpack_public_path__ + "static/media/conn_gtm.ac39b40bcc6dcff9f9b50c0f608f17d7.svg";
export { ForwardRef as ReactComponent };